import {
    CORE_LOAD_CONCURRENT_REQUEST,
    CORE_LOAD_CONCURRENT_SUCCESS,
} from '../../types'

export default {
    concurrents: (state = {}, action) => {
        switch (action.type) {
            case CORE_LOAD_CONCURRENT_REQUEST:
                return []

            case CORE_LOAD_CONCURRENT_SUCCESS:
                return action.payload

            default:
                return state
        }
    },
}


// WEBPACK FOOTER //
// ./src/features/concurrent/reducer.js